import React from 'react'
import PropTypes from 'prop-types'
import { ClearButton, SaveButton } from 'irmlib/components/FormControls'
import { FlexByRow, XDivider, YDivider, HalfScreen } from 'irmlib/styles'
import * as constants from 'irmlib/common/constants'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
// import JobsFilter from '../JobsFilter'
import LocalViewActivityData from './LocalViewActivityData'
import { errorToast } from '../../../common/functions'
import { useTranslation } from 'react-i18next'
import JobsFilter from '../Job/JobsFilter'
import { getUser, persistFilters } from '../../../redux/global'
import { useLocation } from 'react-router-dom'


const Buttons = props =>
  <>
    <ClearButton arrRefs={props.arrRefs} />
    <XDivider width='10px' />
    <SaveButton arrRefs={props.arrRefs} />
  </>

Buttons.propTypes = {
  arrRefs: PropTypes.array
}

const VerticalDivider = () =>
  <YDivider height='15px' />



const LocalViewActivity = (props) => {
  const location = useLocation()
  const pathParams = location?.search?.split('=')
  const dashBoardDistrict = pathParams[1]
  const userVal = getUser()
  const emptyFilter = {
    deType: constants.defaultSelect,
    templateNAme: constants.defaultSelect,
    status: constants.defaultSelect,
    customer: constants.defaultForAccountLevel,
    districts: [constants.defaultSelect],
    orderNumber: constants.defaultForAccountLevel,
    initialStatus: 'APPROVED',
    userName: constants.defaultSelect,
    createDateFrom: constants.defaultSelect,
    createDateTo: constants.defaultSelect
  }
  const { status, district } = persistFilters()
  const statusNavParam = status?.length ? status : [constants.activityStatus.pending, constants.activityStatus.inProgress]
  const selectedDistrict = district?.length ? district : [userVal.district]
  const defDistricts = dashBoardDistrict ? [dashBoardDistrict] : selectedDistrict
  const defaultActiveJobStatus = statusNavParam !== constants.defaultSelect
    ? statusNavParam
    : [
        constants.activityStatus.pending,
        constants.activityStatus.inProgress
      ]
  const [val, Setval] = React.useState({ ...emptyFilter, status: defaultActiveJobStatus, districts: defDistricts, initialStatus: statusNavParam === constants.defaultSelect ? 'NoApprove' : 'APPROVED' }) 
  const { t } = useTranslation()

  const activeJobStatus = [
    { value: constants.activityStatus.pending, label: t(`jobStatusObj.${constants.jobStatus.pending}`) },
    { value: constants.activityStatus.completed, label: t(`jobStatusObj.${constants.jobStatus.completed}`) },
    { value: constants.activityStatus.inProgress, label: t(`jobStatusObj.${constants.activityStatus.inProgress}`) },
    { value: constants.activityStatus.cancel, label: t(`jobStatusObj.${constants.jobStatus.cancel}`) },
  ]

  const getSelectedData = (data) => {
    if (data.District) {
      if (data.District.length) {
        if (data.District.length > 7) {
          errorToast({ message: t('toast.districtSelection'), title: t('toast.failedToFetch'), autoHideDuration: 3000, isBlocking: false })
        } else {
          if (data.Status) {
            if (data.Status.length) {
              Setval({ ...val, status: data.Status, districts: data.District, initialStatus: 'APPROVED' })
            } else {
              errorToast({ message: t('toast.invalidStatus'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
            }
          } else {
            Setval({ ...val, districts: data.District })
          }
        }
      } else {
        errorToast({ message: t('toast.invalidDistrict'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
      }
    } else if (data.Status) {
      if (data.Status.length) {
        Setval({ ...val, status: data.Status, initialStatus: 'APPROVED' })
      } else {
        errorToast({ message: t('toast.invalidStatus'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
      }
    }
  }
  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.smartCatalogLocalRequest'
      // subTitle='routeTitles.myJobs'
    >
      <FlexByRow>
        <HalfScreen>
          <React.Fragment>
            <FlexByRow>
              <JobsFilter defaultStatus={defaultActiveJobStatus} activeStatus={activeJobStatus} selectedData = {getSelectedData}/>
            </FlexByRow>
          </React.Fragment>
        </HalfScreen>
      </FlexByRow>
      <VerticalDivider/>
      <LocalViewActivityData FilterData={val} />
    </MainRouteSubRoutePage>
  )
}

export default LocalViewActivity
